import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { cls } from '@mssgme/helpers';
import { CheckCircleIcon, CircleIcon } from '@mssgme/icons';

import styles from './CheckableItem.scss';

export const CheckableItem = ({ active, disabled, size = 24, children, color, contentClass, ...rest }) => {
    return (
        <div {...cls([styles.root, active && styles.active, disabled && styles.disabled], rest)}>
            <div className={cn(styles.content, contentClass)}>{children}</div>
            <div className={styles.check}>
                {active ? <CheckCircleIcon color={color} size={size} /> : <CircleIcon color={color} size={size} />}
            </div>
        </div>
    );
};

CheckableItem.propTypes = {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.number,
    color: PropTypes.string,
    contentClass: PropTypes.string,
};
